import OrderPage from "../pages/Order";
import Dashboard from "../pages/Dashboard";
import CustomerFeedbackDashboard from "../pages/customerfeedback/index";
import CompletedFeedbacks from "../pages/customerfeedback/CompletedFeedbacks";
import Orders from "../pages/Orders";
import SurgePage from "../pages/admin/SurgePage";
import ItemPriceLogs from "../pages/store/ItemLogs";
import Stores from "../pages/Stores";
import ShiftManagement from "../pages/ShiftManagement";
import ShiftReport from "../pages/ShiftReport";
import SurgeStatsPage from "../pages/admin/SurgeStatsPage";
import ShiftEarnings from "../pages/ShiftEarnings";
import GeneralSettings from "../pages/settings";
import DeliveryGuysPage from "../pages/DeliveryGuysPage";
import Notifications from "../pages/Notifications";
import CashCollections from "../pages/finance/CashCollections";
import CashCollectionLogs from "../pages/finance/CashCollectionLogs";
import StorePayouts from "../pages/finance/StorePayouts";
import StorePayoutRequests from "../pages/finance/StorePayoutRequests";
import StoreEditPage from "../pages/StoreEditPage";
import StoreSortPage from "../pages/StoreSortPage";
import StoreItemsPage from "../pages/StoreItemsPage";
import Analytics from "../pages/settings/Analytics";

import {
    OrderIcon,
    HomeIcon,
    SurgeIcon,
    DeliveryIcon,
    ShiftIcon,
    StoreIcon,
    PriceTagIcon,
    SettingsIcon,
    GeneralIcon,
    WhatsappIcon,
    CouponIcon,
    NotificationIcon, RatingIcon, DeliverySlotIcon, WalletIcon, AccountsIcon, UserIcon, CartIcon,
    CashCollectionIcon, CashCollectionLogIcon, StorePayoutIcon, VersionIcon
} from "./icons";

import WhatsappTemplates from "../pages/settings/WhatsappTemplates";
import Coupons from "../pages/admin/Coupons";
import OrderReviews from "../pages/OrderReviews";
import DeliverySlots from "../pages/DeliverySlots";
import WalletTransactions from "../pages/finance/WalletTransactions";
import Accounts from "../pages/finance/Accounts";
import Customers from "../pages/customer/Customers";
import Carts from "../pages/customer/Carts";
import CouponStatsPage from "../pages/admin/CouponStatsPage";
import HeroImages from "../pages/HeroImages";
import DeliveryAreaProSettings from "../pages/deliveryareapro/DeliveryAreaProSettings";
import VersionAdminPage from "../pages/customer/VersionAdminPage";

// ─────────────────────────────────────────────
// NAV CONFIG
// ─────────────────────────────────────────────

export const NAV = [
    {
        id: "home",
        label: "Home",
        icon: <HomeIcon />,
        to: "/",
        end: true,
        roles: ["admin", "manager", "order_manager"],
    },
    {
        id: "customers",
        label: "Customers",
        icon: <UserIcon />,
        to: "/customers",
        roles: ["admin", "manager", "order_manager"],
        children: [
            { label: "Customer", to: "/customers", icon: <UserIcon />, desc: "View and manage customers" },
            {
                label: "Active Carts",
                to: "/customer/carts",
                icon: <CartIcon />,
                desc: "View live customer carts",
            },

            {
                label: "App Version",
                to: "/customer/app-version",
                icon: <VersionIcon />,
                desc: "Track app version adoption and force updates",
            },
        ],
    },
    {
        id: "orders",
        label: "Orders",
        icon: <OrderIcon />,
        roles: ["admin", "manager", "order_manager"],
        children: [
            {
                label: "Orders",
                to: "/orders",
                icon: <OrderIcon />,
                desc: "View and manage customer orders",
            },
            {
                label: "Order Reviews",
                to: "/orders/reviews",
                icon: <RatingIcon />,
                desc: "View order-wise ratings and reviews",
            },
        ],
    },
    {
        id: "customer-feedback",
        label: "Feedback",
        icon: <OrderIcon />,
        roles: ["customer_feedback", "manager", "admin"],
        children: [
            {
                label: "Pending Feedbacks",
                to: "/feedback/pending",
                icon: <OrderIcon />,
                desc: "Manage pending customer feedbacks",
            },
            {
                label: "Completed Feedbacks",
                to: "/feedback/completed",
                icon: <OrderIcon />,
                desc: "View submitted customer feedbacks",
            },
        ],
    },
    {
        id: "promotions",
        label: "Promotions",
        icon: <CouponIcon />,
        roles: ["admin", "manager"],
        children: [
            {
                label: "Coupons",
                to: "/promotions/coupons",
                icon: <CouponIcon />,
                desc: "Create and manage discount codes",
            },
            {
                label: "Send Notification",
                to: "/promotions/notifications",
                icon: <NotificationIcon />,
                desc: "Push notifications to customers",
            },
            {
                label: "Hero Images",
                to: "/promotions/hero-images",
                icon: <GeneralIcon />, // swap for whatever icon fits
                desc: "Manage homepage hero banner images",
            },
        ],
    },
    {
        id: "delivery-admin",
        label: "Delivery",
        icon: <DeliveryIcon />,
        roles: ["admin", "field_manager", "manager"],
        children: [
            {
                label: "Shifts",
                to: "/shifts",
                icon: <ShiftIcon />,
                desc: "View and manage delivery shifts",
            },
            {
                label: "Delivery Guys",
                to: "/delivery-guys",
                icon: <DeliveryIcon />,
                desc: "Manage all delivery partners",
            },
            {
                label: "Surge",
                to: "/delivery/surge",
                icon: <SurgeIcon />,
                desc: "Manage surge pricing rules",
            },
            {
                label: "Delivery Slots",
                to: "/delivery/slots",
                icon: <DeliverySlotIcon />,
                desc: "Manage delivery slot timings",
            },
        ],
    },
    {
        id: "store",
        label: "Store",
        icon: <StoreIcon />,
        roles: ["admin", "manager"],
        children: [
            {
                label: "Stores",
                to: "/stores",
                icon: <StoreIcon />,
                desc: "Browse and manage all stores",
            },
            {
                label: "Item Price Logs",
                to: "/store/item-logs",
                icon: <PriceTagIcon />,
                desc: "Track item pricing history",
            },
        ],
    },
    {
        id: "Finance",
        label: "Finance",
        icon: <WalletIcon />,
        roles: ["admin", "manager"],
        children: [
            { label: "WalletTransactions", to: "/finance/wallet-transactions", icon: <WalletIcon />, desc: "View wallet transactions" },
            { label: "Accounts", to: "/finance/accounts", icon: <AccountsIcon />, desc: "Manage financial accounts" },
            { label: "CashCollections", to: "/finance/cash-collections", icon: <CashCollectionIcon />, desc: "Manage cash collections" },
            { label: "CashCollectionLogs", to: "/finance/cash-collections/logs", icon: <CashCollectionLogIcon />, desc: "View cash collection logs" },
            { label: "StorePayouts", to: "/finance/store-payouts", icon: <StorePayoutIcon />, desc: "Manage store payouts" },
            { label: "StorePayoutRequests", to: "/finance/store-payouts/requests", icon: <StorePayoutIcon />, desc: "View store payout requests" },
        ],
    },
    {
        id: "settings",
        label: "Settings",
        icon: <SettingsIcon />,
        roles: ["admin", "manager"],
        children: [
            {
                label: "General",
                to: "/settings/general",
                icon: <GeneralIcon />,
                desc: "General application settings",
            },
            {
                label: "WhatsApp Templates",
                to: "/settings/whatsapp-templates",
                icon: <WhatsappIcon />,
                desc: "Manage WhatsApp notification templates",
            },
            {
                label: "Analytics",
                to: "/settings/analytics",
                icon: <GeneralIcon />,
                desc: "Business analytics dashboard"
            }
        ],
    },
];

export function getNavForRole(normalizedRole) {
    return NAV.filter((item) => {
        if (!item.roles) return true;
        return item.roles.includes(normalizedRole);
    });
}

// ─────────────────────────────────────────────
// ROUTE CONFIG
// IMPORTANT:
// Every route inside ROLE_ROUTES should be a route object.
// Do not insert arrays directly.
// Use ...deliveryGuyRoutes, not deliveryGuyRoutes.
// ─────────────────────────────────────────────

const shiftRoutes = [
    {
        path: "/shifts",
        element: <ShiftManagement />,
    },
    {
        path: "/shifts/:shiftId/report",
        element: <ShiftReport />,
    },
    {
        path: "/shifts/:shiftId/earnings",
        element: <ShiftEarnings />,
    },
];

const deliveryGuyRoutes = [
    {
        path: "/delivery-guys",
        element: <DeliveryGuysPage />,
    },
    {
        path: "/delivery/surge",
        element: <SurgePage />,
    },
    {
        path: "/delivery/slots",
        element: <DeliverySlots />,
    },
];


const orderRoutes = [
    {
        path: "/orders",
        element: <Orders />,
    },
    {
        path: "/orders/reviews",
        element: <OrderReviews />,
    },
    {
        path: "/order/:orderId",
        element: <OrderPage />,
    },
];


const deliveryAreaProRoutes = [
    {
        path: "/deliveryareapro/settings",
        element: <DeliveryAreaProSettings />,
    },
];


export const ROLE_ROUTES = {
    customer_feedback: [
        {
            index: true,
            element: <CustomerFeedbackDashboard />,
        },
        {
            path: "/feedback/pending",
            element: <CustomerFeedbackDashboard />,
        },
        {
            path: "/feedback/completed",
            element: <CompletedFeedbacks />,
        },
    ],

    order_manager: [
        {
            index: true,
            element: <Dashboard />,
        },
        {
            path: "/dashboard",
            element: <Dashboard />,
        },
        ...orderRoutes,
        {
            path: "/delivery/surge",
            element: <SurgePage />,
        },
    ],

    field_manager: [
        {
            index: true,
            element: <ShiftManagement />,
        },
        ...deliveryGuyRoutes,
        ...shiftRoutes,
    ],

    default: [
        {
            index: true,
            element: <Dashboard />,
        },
        {
            path: "/dashboard",
            element: <Dashboard />,
        },
        {
            path: "/customers",
            element: <Customers />
        },
        {
            path: "/customer/carts",
            element: <Carts />,
        },
        {
            path: "/customer/app-version",
            element: <VersionAdminPage />,
        },
        {
            path: "/feedback/pending",
            element: <CustomerFeedbackDashboard />,
        },
        {
            path: "/feedback/completed",
            element: <CompletedFeedbacks />,
        },
        ...orderRoutes,
        {
            path: "/promotions/coupons",
            element: <Coupons />,
        },

        {
            path: "/promotions/coupons/:id/stats",
            element: <CouponStatsPage />
        },

        {
            path: "/promotions/notifications",
            element: <Notifications />,
        },
        {
            path: "/store/item-logs",
            element: <ItemPriceLogs />,
        },
        {
            path: "/stores",
            element: <Stores />,
        },
        {
            path: "/stores/edit/:id",
            element: <StoreEditPage />
        },
        {
            path: "/stores/edit/:id/sort",
            element: <StoreSortPage />
        },
        {
            path: "/stores/:id/items",
            element: <StoreItemsPage />
        },
        {
            path: "/stores/:id/items/:itemId",
            element: <StoreItemsPage />
        },
        {
            path: "/surges/:id/stats",
            element: <SurgeStatsPage />,
        },
        {
            path: "/settings/general",
            element: <GeneralSettings />,
        },
        {
            path: "/settings/whatsapp-templates",
            element: <WhatsappTemplates />,
        },
        {
            path: "/settings/analytics",
            element: <Analytics />
        },
        {
            path: "/finance/wallet-transactions",
            element: <WalletTransactions />
        },
        {
            path: "/finance/accounts",
            element: <Accounts />
        },
        {
            path: "/finance/cash-collections",
            element: <CashCollections />
        },
        {
            path: "/finance/cash-collections/logs",
            element: <CashCollectionLogs />
        },
        {
            path: "/finance/store-payouts",
            element: <StorePayouts />
        },
        {
            path: "/finance/store-payouts/requests",
            element: <StorePayoutRequests />
        },
        {
            path: "/promotions/hero-images",
            element: <HeroImages />,
        },
        ...deliveryGuyRoutes,
        ...shiftRoutes,
        ...deliveryAreaProRoutes
    ],
};

// ─────────────────────────────────────────────
// ROUTE RESOLUTION
// ─────────────────────────────────────────────

export function getRoutesForRole(normalizedRole) {
    if (!normalizedRole) {
        return ROLE_ROUTES.default;
    }

    if (ROLE_ROUTES[normalizedRole]) {
        return ROLE_ROUTES[normalizedRole];
    }

    const partialKey = Object.keys(ROLE_ROUTES).find((key) => {
        return key !== "default" && normalizedRole.includes(key);
    });

    return ROLE_ROUTES[partialKey] ?? ROLE_ROUTES.default;
}

// ─────────────────────────────────────────────
// ROLE HOME RESOLUTION
// ─────────────────────────────────────────────

export function getRoleHome(normalizedRole) {
    const routes = getRoutesForRole(normalizedRole);

    const firstConcreteRoute = routes.find((route) => route?.path);

    return firstConcreteRoute?.path ?? "/";
}